<template>
    <div class = "download-wrap pageWrapper">
        <div class = "download-header">
            <CPageTitle title = "下载中心"></CPageTitle>
        </div>
        <div class="search-form-container">
			<Form class="download-center-search-form" :label-width="80" @submit.native.prevent>
				<Input
					class="form-item"
					type="text"
					v-model="params.fileName"
					@on-blur="search"
					placeholder="请输入文件名称"
					search
					@on-enter="search"
				/>
				<Input
					class="form-item"
					type="text"
					v-model="params.operatorName"
					@on-blur="search"
					placeholder="请输入操作人姓名"
					search
					@on-enter="search"
				/>
				<Select class="form-item" :clearable = 'true' v-model="params.state" @on-change="search" placeholder="请输入操作结果">
					<Option :value="1">成功</Option>
                    <Option :value="0">失败</Option>
				</Select>
				<Select class="form-item" :clearable = 'true' v-model="params.type" @on-change="search" placeholder="请输入操作类型">
					<Option :value="0">导入</Option>
                    <Option :value="1">导出</Option>
				</Select>
				<div style="width: 100%; margin-top: 12px;" v-show="arrowDown">
					<DatePicker
						type="datetimerange"
                        format = "yyyy-MM-dd HH:mm:ss"
						@on-change="changeDate"
						class="form-item"
						placeholder="请输入创建时间"
                        v-model = "dateRange"
                        :clearable = 'false'
                        :confirm = 'true'
					></DatePicker>
				</div>
			</Form>
			<div class="btn-right">
				<Button class = "main-color" @click="resetForm" style="">重置</Button>
                <a style="margin-left:12px;" href="javascript:;" @click="toggleSearchForm"
					>{{ arrowText }}<Icon v-if="arrowDown" type="ios-arrow-up"/><Icon v-else type="ios-arrow-down"
				/></a>
			</div>
		</div>
        <Table
            :columns="columnsList" 
            :data="dataList"
            size = "small"
        >

        </Table>
        <div class="pageStyle" style="padding-bottom:40px;">
              <Page 
              show-total show-elevator show-sizer 
              :total="total" 
              :page-size="pageSize" 
              :current="pageNum" 
              @on-change="pageChange"
              @on-page-size-change="changePageSize"
              >
              </Page>
        </div>
    </div>
</template>

<script>
import * as Utils from '../../assets/utils'
import envConst from '../../env-const.js'
export default {
    name: 'downloadCenter',
    data(){
        return {
            columnsList: [],
            dataList: [],
            total: 0,
            pageSize: 10,
            pageNum: 1,
            params: {
                fileName: '',
                operatorName: '',
                type: '',
                state: '',
            },
            dateRange: [Utils.dateFormat(new Date().getTime()-1000*60*60*24),Utils.dateFormat(new Date())],
            arrowDown: false,
			arrowText: '展开'
        }
    },
    created(){
        this.setColumnsList()
        this.getDataList()
    },
    methods: {
        setColumnsList(){
            this.columnsList = [
                {
                    title: "文件名称",
                    align: "left",
                    key: "fileName",
                },
                {
                    title: "操作类型",
                    align: "left",
                    render: (h,{row}) => {
                        return h('span',{
                        },row.type == '1'?'导出':'导入')
                    }
                },
                {
                    title: "操作结果",
                    align: "left",
                    render: (h,{row}) => {
                        return h('span',{
                        },row.state == '1'?'成功':'失败')
                    }
                },
                {
                    title: "操作时间",
                    align: "left",
                    key: "createDate",
                },
                {
                    title: "数据量",
                    align: "left",
                    render: (h,{row}) => {
                        return h('span',{
                        },(row.fileCount ||0)+' 条')
                    }
                },
                {
                    title: "操作人",
                    align: "left",
                    key: "operatorName",
                },
                {
                    title: "操作",
                    align: "left",
                    render: (h,params) => {
                        return h('a',{
                            attrs: {
                                href: `${envConst.API_BASE_URL}/sctm/attachment/downloadAttachment/${params.row.attachmentId}`,
                                download: true
                            }
                        },'下载')
                    }
                },
            ]
        },
        getDataList(pageNum){
            let {fileName,operatorName,type,state,startDate,endDate} = this.params
            this.$http.get('/sctm/attachment/getAttachmentByParam',{
                params: {
                    fileName,
                    operatorName,
                    type,
                    state,
                    startDate:Utils.dateFormat(this.dateRange[0]),
                    endDate:Utils.dateFormat(this.dateRange[1]),
                    pageSize: this.pageSize,
                    pageNum: pageNum||this.pageNum
                }
            }).then(({data}) =>{
                if(data.returnCode === 0){
                    this.dataList = data.beans
                    this.total = data.bean.total
                }
            })
        },
        search(){
            this.pageNum = 1
            this.getDataList()
        },
        pageChange(pageNum){
            this.pageNum = pageNum
            this.getDataList()
        },
        changePageSize(pageSize){
            this.pageSize = pageSize
            this.getDataList()
        },
        changeDate: function(dates) {
            this.dateRange = [...dates]
            this.search()
        },
        resetForm(){
            this.params= {
                fileName: '',
                operatorName: '',
                type: '',
                state: '',
            }
            this.dateRange= [Utils.dateFormat(new Date().getTime()-1000*60*60*24),Utils.dateFormat(new Date())]
            this.search()
        },
        toggleSearchForm: function() {
			this.arrowDown = !this.arrowDown
			this.arrowText = this.arrowDown ? '收起' : '展开'
		},
    }
}
</script>

<style lang = "less" scoped>
.download-wrap{
    height:100%;
    width:100%;
    overflow: auto;
    .download-header{
        margin-bottom:25px;
    }
}
.save-button {
	float: right;
	margin-left: 20px;
}
.search-form-container {
	height: auto;
	display: flex;
}
.search-form-container .download-center-search-form {
	flex: 1;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
    margin-bottom:20px;
}
.search-form-container .download-center-search-form .form-item {
	width: calc(25% - 12px);
	margin-right: 12px;
}
.search-form-container .download-center-search-form .form-item:last-of-type {
	margin-right: 16px;
}
.btn-right{
	flex: 0 0 108px;
	box-sizing: border-box;
	padding-left: 4px;
}
</style>